export const showNoLaptopWarning = () =>
  import('sweetalert').then((swal) => {
    swal.default({
      icon: 'warning',
      title:
        'You cannot attend the class without a laptop/PC and a good internet connection.',
    })
  })
